import { useState } from "react";

function useSearchField(data: string[]) {
  const [filteredList, setFilteredList] = useState<any>([]);

  const arrayConverted = data && Object.keys(data).map((k: any) => data[k]);

  const searchList = (query: string) => {
    setTimeout(() => {
      let filteredData;

      if (!query.trim().length) {
        filteredData = [...arrayConverted];
      } else {
        filteredData = arrayConverted?.filter((item) => {
          return item.toLowerCase().includes(query.toLowerCase());
        });
      }

      setFilteredList(filteredData);
    }, 250);
  };

  return { filteredList, searchList };
}

export default useSearchField;
